// extracted by mini-css-extract-plugin
export default {"tooltip":"YV-z","arrow":"ZV-z"};